<template>
  <div class="">
    <Container class="pointer-events-none relative z-10 h-full pt-24 text-white lg:flex lg:items-center lg:pt-0">
      <div class="w-full">
        <AnimatedText
          :copy="title"
          tag="h2"
          :visible="visible"
          class="max-w-2xl text-4xl leading-tight sm:text-7xl sm:leading-tight" />
        <AnimatedText
          :copy="copy"
          :visible="visible"
          tag="p"
          class="ml-auto mt-8 max-w-md text-2xl leading-tight sm:text-3xl sm:leading-tight lg:mt-24" />
      </div>
    </Container>
    <ThreeImageSequence
      :progress="progress"
      class="h-scren absolute top-0" />
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'

  import AnimatedText from './animated-text.vue'

  type type3dProps = {
    title: string
    copy: string
    progress: number
  }

  const props = defineProps<type3dProps>()
  const visible = ref(true)

  watch(
    () => props.progress,
    progress => {
      if (progress > 1) {
        visible.value = false
      } else {
        visible.value = true
      }
    }
  )
</script>
